import type { FaireProductEntity } from "../../entity_types/product";

export const p_xhhczgxdks: FaireProductEntity = {
  token: "p_xhhczgxdks",
  type: "product",
  name: "LM-BN-1005 LULU MAC PATCH BEANIE BLACK",
  brandToken: "b_h6l667zq",
  brandName: "Girlie Girl Originals",
  imageUrl: "https://cdn.faire.com/fastly/199974de6cb796aa8466ace72e6f1dee99db952eb939ebf58909fcab175336f5.jpeg",
  galleryImageUrls: [],
  priceDollars: 10,
  description: "Whether it’s for function or style, hair clips are a fun accessory for everyday use. Check out our variety of colors and sizes! \n",
  tags: [],
  msrpDollars: 20,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:02:07.170Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
